const M = (t) => typeof t == "function" ? t() : t, i = (t, e) => new Intl.NumberFormat(e || "en-US", { useGrouping: !1 }).format(t), u = (t, e) => String(Math.ceil(t)).padStart(e ?? 2, "0"), h = (t) => t === 0 ? 12 : t === 12 ? 0 : t > 12 ? t - 12 : t, w = (t) => t >= 12 ? "PM" : "AM", D = (t, e) => e === "AM" ? t === 12 ? 0 : t : t === 0 ? 12 : t === 12 ? t : t + 12;
function S() {
  const t = /* @__PURE__ */ new Date();
  let e = t.getHours(), r = "AM";
  return e > 12 && (e -= 12, r = "PM"), e === 12 && (r = "PM"), e === 0 && (e = 12), { hour: e, minute: t.getMinutes(), second: t.getSeconds(), meridiem: r };
}
function f({ startYear: t, endYear: e, count: r, year: l, yearRange: a, locale: c }) {
  const n = l || (/* @__PURE__ */ new Date()).getFullYear();
  if (!t) {
    const g = Math.floor(n / r) * r;
    t = g === n ? n - r + 1 : g + 1;
  }
  e || (e = t + r - 1);
  const o = [];
  let d = t, p = e;
  for (let g = t; g <= e; g++)
    a != null && a.start && g < (a == null ? void 0 : a.start) ? (o.push(""), d = a == null ? void 0 : a.start) : a != null && a.end && g > (a == null ? void 0 : a.end) ? (o.push(""), p = a == null ? void 0 : a.end) : o.push(i(g, c));
  return { array: o, range: `${i(d, c)} - ${i(p, c)}`, startYear: t, endYear: e };
}
const m = (t) => {
  let e;
  return e = typeof t == "string" || typeof t == "number" ? new Date(t) : t instanceof Date ? t : new Date(t.year || 2023, t.month || t.month === 0 ? t.month : 1, t.day), e;
}, x = (t) => ({ year: t.getFullYear(), month: t.getMonth(), day: t.getDate() }), L = (t) => {
  const e = /* @__PURE__ */ new Date(), r = (t == null ? void 0 : t.year) ?? e.getFullYear(), l = (t == null ? void 0 : t.month) === 0 ? 0 : (t == null ? void 0 : t.month) ?? e.getMonth(), a = (t == null ? void 0 : t.day) ?? e.getDate();
  return new Date(r, l, a);
}, R = (t, e) => {
  const { localeOptions: r, locale: l, format: a } = e || {}, c = m(t);
  return y({ date: c, option: r || { month: "short", day: "numeric", year: "numeric" }, locale: l, format: a });
}, y = ({ format: t, option: e, date: r, locale: l }) => t ? ((a, c, n = "en-US") => {
  const o = m(a);
  return c.replace(new RegExp("(?<!~)(?<!y)yyyy(?!y)", "g"), o.toLocaleString(n, { year: "numeric" })).replace(new RegExp("(?<!~)(?<!y)yy(?!y)", "g"), o.toLocaleString(n, { year: "2-digit" })).replace(new RegExp("(?<!~)(?<!m)m(?!m)", "g"), o.toLocaleString(n, { month: "numeric" })).replace(new RegExp("(?<!~)(?<!m)mm(?!m)", "g"), o.toLocaleString(n, { month: "2-digit" })).replace(new RegExp("(?<!~)(?<!d)dd(?!d)", "g"), o.toLocaleString(n, { day: "2-digit" })).replace(new RegExp("(?<!~)(?<!d)d(?!d)", "g"), o.toLocaleString(n, { day: "numeric" })).replace(new RegExp("(?<!~)(?<!D)DDD(?!D)", "g"), s(o.toLocaleString(n, { weekday: "long" }))).replace(new RegExp("(?<!~)(?<!D)DD(?!D)", "g"), s(o.toLocaleString(n, { weekday: "short" }))).replace(new RegExp("(?<!~)(?<!D)D(?!D)", "g"), s(o.toLocaleString(n, { weekday: "narrow" }))).replace(new RegExp("(?<!~)(?<!M)MMM(?!M)", "g"), o.toLocaleString(n, { month: "long" })).replace(new RegExp("(?<!~)(?<!M)MM(?!M)", "g"), o.toLocaleString(n, { month: "short" })).replace(new RegExp("(?<!~)(?<!M)M(?!M)", "g"), o.toLocaleString(n, { month: "narrow" })).replace(/~y/g, "y").replace(/~m/g, "m").replace(/~M/g, "M").replace(/~d/g, "d").replace(/~D/g, "D");
})(r, t, l) : r.toLocaleDateString(l ?? "en-US", e), s = (t) => t.startsWith("M") ? "~" + t : t, E = (t) => t === 0 ? 12 : t !== void 0 ? u(t) : "", v = (t) => t !== void 0 ? u(t) : "";
export {
  L as a,
  h as b,
  x as c,
  w as d,
  D as e,
  R as f,
  m as g,
  S as h,
  u as i,
  M as j,
  f as k,
  y as l,
  E as m,
  v as n,
  i as o
};
